module.exports = __webpack_public_path__ + "img/opera-logo.3783e4d8.svg";